<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <div style="color:green" [innerHTML]="data.text"></div><br>
  <div>
    @for (container of data.containers; track container) {
      <input type="checkbox" value="{{ container.isChecked }}" [checked]="container.isChecked" (change)="container.isChecked = !container.isChecked" /><mat-label style="font-size:medium"> {{container.id}} </mat-label><mat-label style="font-size:x-small"> {{container.daysOnSite}} day(s)</mat-label>
      <br>
        }<br>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      @if (data.showCancel) {
        <button class="btn btn-light" mat-button mat-dialog-close>Cancel</button>
      }
      @if (containersChecked(data.containers)) {
        <button class="btn btn-primary" mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
      }
    </mat-dialog-actions>
